import { CheckCircle2 } from "lucide-react";
import { BRANDING_THEME as BRAND_COLORS } from "../../../constants/brandingTheme";

/** Registro de pago manual (SPEI) + historial. `onRegister` lo maneja SuperadminPanel. */
export default function ClientPayments({ editingData, paymentForm, setPaymentForm, payments, computePrice, onRegister }) {
  return (
    <>
      {/* Registrar pago manual SPEI */}
      <div className="mb-4">
        <h5 className="h6 d-flex align-items-center gap-2 mb-3" style={{ color: BRAND_COLORS.primary.main, fontSize: '0.9rem' }}>
          Registrar pago (SPEI)
        </h5>
        <div className="superadmin-config-fields">
          <div className="app-form-group">
            <label className="app-form-label small" style={{ color: BRAND_COLORS.text.secondary, fontSize: '0.8rem' }}>Meses a pagar</label>
            <input
              className="app-form-control"
              type="number"
              min="1"
              inputMode="numeric"
              value={paymentForm.periodMonths}
              onChange={(e) => setPaymentForm((pf) => ({ ...pf, periodMonths: e.target.value }))}
              onBlur={(e) => setPaymentForm((pf) => ({ ...pf, periodMonths: Math.max(1, parseInt(e.target.value, 10) || 1) }))}
            />
          </div>
          <div className="app-form-group">
            <label className="app-form-label small" style={{ color: BRAND_COLORS.text.secondary, fontSize: '0.8rem' }}>Referencia / folio (opcional)</label>
            <input
              className="app-form-control"
              value={paymentForm.reference}
              onChange={(e) => setPaymentForm((pf) => ({ ...pf, reference: e.target.value }))}
              placeholder="Ej: folio SPEI"
            />
          </div>
          {/* Override de vigencia: para altas a mitad de mes, donde el
              corte debe caer en un día fijo (ej. el 1ro) y no a +1 mes de hoy. */}
          <div className="app-form-group">
            <label className="app-form-label small" style={{ color: BRAND_COLORS.text.secondary, fontSize: '0.8rem' }}>Vigencia hasta (opcional)</label>
            <input
              className="app-form-control"
              type="date"
              value={paymentForm.expiresAt}
              onChange={(e) => setPaymentForm((pf) => ({ ...pf, expiresAt: e.target.value }))}
            />
          </div>
          <div className="app-form-group">
            <label className="app-form-label small" style={{ color: BRAND_COLORS.text.secondary, fontSize: '0.8rem' }}>Total a cobrar</label>
            <div className="app-form-control d-flex align-items-center" style={{ backgroundColor: BRAND_COLORS.backgrounds.tertiary, color: BRAND_COLORS.primary.main, borderColor: BRAND_COLORS.borders.light, fontWeight: 700 }}>
              ${computePrice(editingData.seats, editingData.addonsNextCycle) * (Number(paymentForm.periodMonths) || 1)} MXN
            </div>
          </div>
        </div>
        <button
          className="app-btn app-btn-primary mt-2"
          onClick={onRegister}
          style={{ background: BRAND_COLORS.gradients.primary }}
        >
          <CheckCircle2 className="me-1" size={16} />
          Registrar pago y extender suscripción
        </button>
        <small className="d-block mt-2" style={{ color: BRAND_COLORS.text.muted, fontSize: '0.7rem' }}>
          {paymentForm.expiresAt
            ? "La vigencia quedará exactamente en la fecha elegida (fin del día, hora de México) y se ignoran los meses."
            : "Extiende la expiración desde la fecha vigente (o desde hoy si ya venció) y reactiva la suscripción."}
        </small>

        {/* Historial de pagos */}
        <div className="mt-3">
          <label className="app-form-label small d-block mb-2" style={{ color: BRAND_COLORS.text.secondary, fontSize: '0.8rem' }}>
            Historial de pagos {payments.length > 0 && `(${payments.length})`}
          </label>
          {payments.length === 0 ? (
            <p className="small mb-0" style={{ color: BRAND_COLORS.text.muted, fontSize: '0.75rem' }}>Sin pagos registrados.</p>
          ) : (
            <div className="d-flex flex-column gap-2">
              {payments.map((p) => (
                <div
                  key={p._id}
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: BRAND_COLORS.backgrounds.primary,
                    border: `1px solid ${BRAND_COLORS.borders.light}`,
                    borderRadius: '6px',
                    padding: '0.5rem 0.75rem',
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <span className="d-block" style={{ color: BRAND_COLORS.text.primary, fontSize: '0.8rem', fontWeight: 600 }}>
                      ${p.amount} MXN · {p.periodMonths || 1} {(p.periodMonths || 1) === 1 ? "mes" : "meses"}
                    </span>
                    <span className="d-block text-truncate" style={{ color: BRAND_COLORS.text.muted, fontSize: '0.7rem' }}>
                      {p.paidAt ? new Date(p.paidAt).toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" }) : "—"}
                      {p.method ? ` · ${p.method.toUpperCase()}` : ""}
                      {p.reference ? ` · ${p.reference}` : ""}
                    </span>
                  </div>
                  <span
                    className="text-nowrap text-end"
                    title="Nueva fecha de vigencia tras este pago"
                    style={{ color: BRAND_COLORS.primary.main, fontSize: '0.7rem', fontWeight: 600 }}
                  >
                    Vence<br />
                    {p.newExpiresAt ? new Date(p.newExpiresAt).toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" }) : "—"}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
